roleTypes = function (admin) {

	var objRoleTypes = {};
	var newParent = null;
	var objDialog = dialog();


	/* conflict resolution vars */
	var stepsSize = 0;
	var entitiesSize = 0;
	var entities = '';
	var steps = '';
	var replaceRoleTypeResult = '';
	var replaceStepRoleTypeResult = '';
	var apEditmodeOriginal = [];
	var apEditmodeEditing = [];

	var url = '/admin/';
	if (admin === undefined || admin === null) {
		url = '/admin/';
	} else if(admin) {
		url = '/admin/';
	} else if(!admin) {
		url = '/';
	}

	/*
	 * Function createRoleTypeList
	 * Purpose: populates the role types list in the right types column
	 */
	objRoleTypes.createRoleTypeList = function(show) {
		var params = {
			display : 'ajaxList'
		};

		$.ajax({
			url: '/admin/roleType',
			type: 'get',
			data: params,
			beforeSend: function() {
				domObject.addLoadingMask('#curriculog-types-column-content');
			},
			success: function(data) {

				$('.hierarchy-types').removeClass('active');
				$('#role-types').remove();
				$(data).appendTo('#curriculog-types-column-content');
				objRoleTypes.createRoleTypeSelect();

				if (show === true) {
					$('#role-types').addClass('active');
				}

				domObject.removeMask('#curriculog-types-column-content');
				objRoleTypes.verticalStretch();
			}
		});

	};


	/*
	 * Function createRoleTypeSelect
	 * Purpose: populates the role types dropdown inside the role dialog
	 */

	objRoleTypes.createRoleTypeSelect = function() {
		$('#entity-roles-available').contents().remove();

		if($('#role-types .curriculog-types-current-type').length <= 1) {
			$('#entity-roles-available').append('<option value="" disabled="disabled">No Role Types</option>');
			$('.entity-role-add').addClass('disabled');
		} else {
			$('#role-types .curriculog-types-current-type').each(function() {
				// put all role types except originator into the dropdown
				if ($(this).find('.type-name').text() !== 'Originator') {
					var option = $('<option></option>');
					var optionText = $(this).children('.type-name').text();
					if ($(this).find('.type-name').hasClass('committee-roleType')) {
						option.attr('class', 'role-committee');
						optionText += ' (committee)';
					}
					option.val(($(this).attr('id')).replace('role-type-',''));
					option.text(optionText);
					$('#entity-roles-available').append(option);
				}
			});
			$('.entity-role-add').removeClass('disabled');
		}

	};

	objRoleTypes.createRoleTypeSelectAjax = function(selectId) {
		$.get(url + 'roleType.json', {}, function(data) {
			$('#' + selectId).contents().remove();
			if (data.hasOwnProperty('types')){
				$.each(data.types, function(index, roleType) {
					// append option with appropriate non-breaking spaces to the select box
					escapedRoleTypeName = escapeUserInput(roleType.name);
					$('#' + selectId).append($('<option></option>').val(roleType.id).html(escapedRoleTypeName));
				});
			}
		});
	};

	// objRoleTypes.refreshList = function() {
	// 	try {
	// 		var setActive = false;
	// 		// XXX Name selectors something descriptive.
	// 		var whatami = $('div#curriculog-types-column-tooltabs li.active')
	// 			.attr('id')
	// 			.replace('-tab', '');
	// 		if (whatami === 'role-types') {
	// 			setActive = true;
	// 		}

	// 		objRoleTypes.createRoleTypeList(setActive);
	// 	} catch (e) {}
	// };

	/*
	 * Function newRoleType
	 * Purpose: gathers information from the form to update
	 * or create new role type
	 */
	// objRoleTypes.newRoleType = function() {
	// 	try {
	// 		// Disable the form
	// 		$('#role-types .type-submit').attr('disabled', 'disabled');

	// 		var id = myUniquer.create();

	// 		var postData = {
	// 			name:$('#role-type-name').val(),
	// 			committee: $('#role-type-committee:checked').length ? 1 : 0,
	// 		};

	// 		if ($('#role-type-id').val().trim().length !== 0) {

	// 			var hasCommittee = +$('#role-type-committee').val();

	// 			var roleTypeObj = {
	// 				id: $('#role-type-id').val().trim(),
	// 				name: $('#role-type-name').val(),
	// 				type: ''
	// 			};

	// 			if (+postData.committee === 0 && hasCommittee === 1) {
	// 				var urlPut = '/admin/roleType:' + $('#role-type-id').val().trim() + '.json';
	// 				$.ajax({
	// 					url: urlPut,
	// 					type: 'put',
	// 					data: postData,
	// 					beforeSend: function() {
	// 						domObject.addLoadingMask('.curriculog-types-new-type');
	// 					},
	// 					success: function(){
	// 						domObject.removeMask('.curriculog-types-new-type');
	// 						objRoleTypes.createRoleTypeList(true);
	// 					}
	// 				});
	// 			} else {
	// 				// we are adding committe to roleType
	// 				var urlPut = '/admin/roleType:' + $('#role-type-id').val().trim() + '.json';
	// 				$.ajax({
	// 					url: urlPut,
	// 					type: 'put',
	// 					data: postData,
	// 					beforeSend: function() {
	// 						domObject.addLoadingMask('.curriculog-types-new-type');
	// 					},
	// 					success: function(){
	// 						domObject.removeMask('.curriculog-types-new-type');
	// 						objRoleTypes.createRoleTypeList(true);
	// 					}
	// 				});
	// 			}

	// 		} else {
	// 			$.ajax({
	// 				url: '/admin/roleType',
	// 				type: 'POST',
	// 				data: postData,
	// 				beforeSend: function() {
	// 					domObject.addLoadingMask('.curriculog-types-new-type');
	// 				},
	// 				success: function(){
	// 					domObject.removeMask('.curriculog-types-new-type');
	// 					objRoleTypes.createRoleTypeList(true);
	// 				}
	// 			});
	// 		}
	// 	} catch (err) {
	// 		return false;
	// 	}
	// };

	// objRoleTypes.editRoleType = function(typeId) {
	// 	try {
	// 		if (typeId === undefined) {
	// 			return false;
	// 		}

	// 		// Set role name in form
	// 		$('#role-type-name').val($('#' + typeId + ' .type-name').html().trim());

	// 		// is this a committee
	// 		if ($('#' + typeId + ' .type-name').hasClass('committee-roleType')) {
	// 			$('#role-type-committee').prop('checked', 'checked');
	// 			$('#role-type-committee').val(1);
	// 		}
	// 		else {
	// 			$('#role-type-committee').prop('checked', '');
	// 			$('#role-type-committee').val(0);
	// 		}
	// 		$('#role-type-committee').attr('disabled',true);

	// 		//Set role type id
	// 		$('#role-type-id').val(typeId.replace('role-type-', ''));

	// 		// Change submit button to say 'Update Type'
	// 		$('#role-types .type-submit').attr('value','Update Type').removeAttr('disabled');
	// 		$('#role-types .type-reset').removeAttr('disabled');
	// 		$('#role-types li.curriculog-types-new-type form h1').text('Update Role Type');
	// 	} catch(err) {
	// 		return false;
	// 	}
	// };

	// objRoleTypes.resetRoleTypeForm = function() {
	// 	try {
	// 		//Set role type id
	// 		$('#role-type-id').val('');
	// 		$('#role-type-committee').val('');

	// 		// Change submit button to say 'Update Type'
	// 		$('#role-types .type-submit').attr('value','Create Type');
	// 		$('#role-types li.curriculog-types-new-type form h1').text('New Role Type');
	// 		objRoleTypes.createRoleTypeList(true);
	// 	} catch(err) {
	// 		return false;
	// 	}
	// };

	// objRoleTypes.validateForm = function(typeId, which) {
	// 	if (which !== 13) {
	// 		if ($(typeId).val().trim() === '' && !$('#role-type-committee').is(':checked')) {
	// 			$('#role-types .type-submit').attr('disabled', 'disabled');
	// 			$('#role-types .type-reset').attr('disabled', 'disabled');
	// 		} else if ($(typeId).val().trim() === '' && $('#role-type-committee').is(':checked')) {
	// 			$('#role-types .type-submit').attr('disabled', 'disabled');
	// 			$('#role-types .type-reset').removeAttr('disabled');
	// 		} else {
	// 			$('#role-types .type-submit').removeAttr('disabled');
	// 			$('#role-types .type-reset').removeAttr('disabled');
	// 		}
	// 	}
	// };

	objRoleTypes.deleteFailed = function(currentId) {
		try {
			if (currentId === undefined) {
				return false;
			}

			var typeId = 'role-type-' + currentId;

			$('#' + typeId).addClass('curriculog-remove-warning-highlight');
			var dialog = objDialog.createBasicWarningDialog('role-type-delete-failed', function(dialog, defaults) {
				// Message
				$(dialog).append('The "' + $('#' + typeId + ' .type-name').html() + '" role type could not be deleted at this time.');
				// Actions
				defaults.buttons = {
					'Ok': function() {
						$('#' + typeId).removeClass('curriculog-remove-warning-highlight');
						$(this).dialog('close');
						$(this).remove();
					}
				};
				$(dialog).dialog(defaults);
			});
		} catch(err){
			return false;
		}
	};

	objRoleTypes.verticalStretch = function() {
		var col1 = '#curriculog-hierarchy-column-content';
		var col2 = '#curriculog-types-column-content';
		domObject = dom();
		domObject.verticalStretchForm(col1, col2);
	};


	/*
	* CONFLICT RESOLUTION
	*/
	objRoleTypes.getRoleTypeSelector = function(selectId, data) {
		$('#' + selectId).contents().remove();
		$('#' + selectId).append($('<option></option>').val(-1).html('Please Select a Role Type'));
		$.each(data, function(roleTypeId, roleTypeName) {
			// append option with appropriate non-breaking spaces to the select box
			$('#' + selectId).append($('<option></option>').val(roleTypeId).html(roleTypeName));
		});
	};

	objRoleTypes.getRoleTypeData = function(roleTypeId, isCommittee) {
		roleTypesList = {};
		$.ajax({
			url: '/admin/roleType.json',
			type: 'GET',
			async:false,
			success: function(data) {
				if (data.hasOwnProperty('types')) {
					$.each(data.types, function(index, roleType) {
						if (roleTypeId !== roleType.id) {
							if (isCommittee) {
								if (roleType.committee > 0) {
									roleTypesList[+roleType.id] = roleType.name;
								}
							} else {
								roleTypesList[+roleType.id] = roleType.name;
							}
						}
					});
				}
			}
		});

		return roleTypesList;
	};

	objRoleTypes.getNonCommitteeRoleTypes = function() {
		roleTypesList = {};

		// get roleTypes already used for entity
		nonSelectable = [];
		$('#entity-roles').children('li').each(function(index) {
			nonSelectable.push(+$(this).find('input[name="role[' + index + '][roleTypeID]"]').val());
		});

		$.ajax({
			url: '/admin/roleType.json',
			type: 'GET',
			async:false,
			success: function(data) {

				if(data.hasOwnProperty('types')) {
					$.each(data.types, function(index, roleType) {

						if (+roleType.committee === 0 && $.inArray(+roleType.id, nonSelectable) === -1) {
							roleTypesList[+roleType.id] = roleType.name;
						}
					});
				}
			}
		});

		return roleTypesList;
	};

	objRoleTypes.removeRoleTypeConflict = function(roleTypeId) {

		// display selector
		var dialog = objDialog.createDOMDialog('remove-roleType-conflict', function(dialog, defaults) {

			defaults.buttons = {
				'Remove Role Type': function() {

					$.ajax({
						url: '/admin/roleType:'+roleTypeId+'/replaceType.json',
						type: 'DELETE',
						beforeSend: function() {
							objDom.addMask('#role-types');
						},
						success: function(result) {

							$('#role-type-' + roleTypeId).addClass('curriculog-remove-warning-highlight');
							if (+result.success === 1) {
								objRoleTypes.createRoleTypeList(true);
								//objRoleTypes.clearMongoData(roleTypeId);
							} else {
								objRoleTypes.deleteFailed('role-type-' + roleTypeId);
							}

							objDom.removeMask('#role-types');

						}
					});
					$(this).dialog('close');
				},
				Cancel: function() {
					//objRoleTypes.clearMongoData(roleTypeId);
					$(this).dialog('close');
				}
			};
			$(dialog).dialog(defaults);

		});
	};

	objRoleTypes.deleteRoleType = function(typeId) {
		objRoleTypes.removeRoleTypeConflictResolution(typeId.split('-')[2]);
	};


	objRoleTypes.replaceCommitteeRoleType = function(roleTypeId, callback) {

		// display selector
		var dialog = objDialog.createDOMDialog('replace-roletype-dialog', function(dialog, defaults) {

			defaults.buttons = {
				'Replace Role Type': function() {

					var errors = false;

					$('#replace-roleType-data .replace-roleType-selector').filter(function() {
						return this.id.match(/^replace-roleType-select-[0-9]*$/);
					})
					.each(function(index) {
						if (+$(this).val() === -1) {
							errors = true;
							$(this).parents('div').children('.replace-roles-roleType-roleName').addClass('curriculog-remove-warning-highlight');
						} else {
							$(this).parents('div').children('.replace-roles-roleType-roleName').removeClass('curriculog-remove-warning-highlight');
						}

					});


					if (errors) {
						alert('You need to select a new Role Type for the highlighted ones you missed.');
						return;
					} else {
						var newRoleType = $('#replace-roleType-select-' + roleTypeId).val();

						$.ajax({
							url: '/admin/roleType:' + roleTypeId + '/replaceRoleType.json',
							type: 'PUT',
							data: {newRoleTypeId:newRoleType},
							success: function (result) {
								$('#role-type-' + roleTypeId).removeClass('curriculog-remove-warning-highlight');
								objDom.removeMask('#role-types');
								callback && callback();
							}
						});
					}
					$(this).dialog('close');
				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};
			defaults.width = 800;
			$(dialog).dialog(defaults);

		});
	};

	// objRoleTypes.deleteRoleType = function(typeId) {
	// 	objRoleTypes.removeRoleTypeConflictResolution(typeId.split('-')[2]);
	// };


	objRoleTypes.beforeDelete = function(obj) {
		objRoleTypes.destroy(obj);
	};


	objRoleTypes.destroy = function(obj) {
		// display selector
		var dialog = objDialog.createBasicWarningDialog('remove-roleType-conflict', function(dialog, defaults) {
			$(dialog).append('Are you sure that you want to remove the role type "' + obj.name + '"?');

			var close = function () {
				$(this).dialog('close');
				$(this).remove();
			};

			defaults.buttons = {
				'Delete': function() {
					$.ajax({
						url: '/admin/roleType:' + obj.id,
						type: 'DELETE',
						beforeSend: function() {
							objDom.addMask('#role-types');
						},
						success: function(result) {
							$('#role-type-' + obj.id).remove();
							objDom.removeMask('#role-types');
						}
					});
					close.call(this);
				},

				'Cancel': close
			};
			$(dialog).dialog(defaults);
		});
	};

	objRoleTypes.deleteOptions = function(obj, callback) {
		var dialog = objDialog.createBasicWarningDialog('role-type-delete-options', function(dialog, defaults) {
			// Message
			$(dialog).append('Before we calculate for conflicts, would you like to delete all role associated with this roleType or select a new RoleType for each role?');

			// Actions
			defaults.buttons = {
				'Delete Roles': function() {
					obj.replace = 2;
					callback && callback(obj);
					$(this).dialog('close');
					$(this).remove();
				},
				'Replace RoleType': function() {
					obj.replace = 1;
					callback && callback(obj);
					$(this).dialog('close');
					$(this).remove();
				},
				'Cancel': function() {
					$(this).dialog('close');
					$(this).remove();
				}
			};
			$(dialog).dialog(defaults);
		});
	};

	return objRoleTypes;
};